<template>
  <div v-if="fieldsData !== undefined" id="pageFields" :style="{ top: offsetTop + 'px', left: offsetLeft + 'px' }">
    <template
      v-if="(
        $store.state.showFields &&
        typeof $store.state.templates[$store.state.currentTemplateName] !== 'undefined'
      )"
    >
      <template v-for="(field, index) in fieldsData" v-if="field.type !== undefined">
        <template v-if="field !== null && field.height > 35 || field.type.toLowerCase() === 'textarea'">
          <form-textarea class="behind" :key="index"
            :id="field.id"
            :model="field.model"
            :width="(field.width * $store.state.pageScale)"
            :height="(field.height * $store.state.pageScale)"
            :left="(field.x * $store.state.pageScale)"
            :top="(field.y * $store.state.pageScale)"
            :fontSize="($store.getters.fontScale())"
            :tabOrder="field.tabOrder"
            :listOfficialModels="listOfficialModels"
            @set-autocomplete:model="setAutcompleteModel">
          </form-textarea>
        </template>

        <template v-else-if="field !== null && field.type.toLowerCase() === 'text'">
          <form-text class="behind" :key="index"
            :id="field.id"
            :model="field.model"
            :width="(field.width * $store.state.pageScale)"
            :height="(field.height * $store.state.pageScale)"
            :left="(field.x * $store.state.pageScale)"
            :top="(field.y * $store.state.pageScale)"
            :fontSize="($store.getters.fontScale())"
            :tabOrder="field.tabOrder"
            :type="field.type"
            :listOfficialModels="listOfficialModels"
            @set-autocomplete:model="setAutcompleteModel">
          </form-text>
        </template>

        <template v-else-if="field !== null && (field.type.toLowerCase() === 'checkbox' || field.type.toLowerCase() === 'button')">
          <form-checkbox class="front" :key="index"
            :id="field.id"
            :model="field.model"
            :width="(field.width * $store.state.pageScale)"
            :height="(field.height * $store.state.pageScale)"
            :left="(field.x * $store.state.pageScale)"
            :top="(field.y * $store.state.pageScale)"
            :tabOrder="field.tabOrder"
            :value="field.value"
            :listOfficialModels="listOfficialModels">
          </form-checkbox>
        </template>

        <template v-else-if="field !== null && field.type.toLowerCase() === 'select'">
          <form-select class="front" :key="index"
            :id="field.id"
            :model="field.model"
            :width="(field.width * $store.state.pageScale)"
            :height="(field.height * $store.state.pageScale)"
            :left="(field.x * $store.state.pageScale)"
            :top="(field.y * $store.state.pageScale)"
            :options="field.choiceData"
            :tabOrder="field.tabOrder"
            :listOfficialModels="listOfficialModels">
          </form-select>
        </template>

        <template v-else-if="field !== null && field.type.toLowerCase() === 'radio'">
          <!-- <p>Implement radio</p> -->
          <form-checkbox class="front" :key="index"
            :id="field.id"
            :model="field.model"
            :width="(field.width * $store.state.pageScale)"
            :height="(field.height * $store.state.pageScale)"
            :left="(field.x * $store.state.pageScale)"
            :top="(field.y * $store.state.pageScale)"
            :tabOrder="field.tabOrder">
          </form-checkbox>
        </template>
      </template>
    </template>

    <autocomplete-model
      v-if="isAutocompleteModel === true"
      :data="autocompleteModelData"
      :model="autocompleteModel"
    />
  </div>
</template>

<script>
  import FormText from '@/components/editor/inputs/FormText'
  import FormTextarea from '@/components/editor/inputs/FormTextarea'
  import FormCheckbox from '@/components/editor/inputs/FormCheckbox'
  import FormSelect from '@/components/editor/inputs/FormSelect'

  import AutocompleteModel from '@/components/editor/modal-edit/AutocompleteModel.vue'

  export default {
    name: 'page-fields',

    data () {
      return {
        offsetTop: 0,
        offsetLeft: 0,
        height: 0,
        width: 0,
        fieldsData: {},

        isAutocompleteModel: false,
        autocompleteModelData: null,
        autocompleteModel: '',
        listOfficialModels: []
      }
    },

    created () {
      this.listOfficialModels = this.$store.state.officialModels
    },

    mounted () {
      let that = this

      this.setup()
      this.$bus.on('pageChange', this.resetData)
      this.$bus.on('resetTabOrders', this.resetTabOrders)
      this.$bus.on('historyChange', this.resetData)
      this.$bus.on('toggleModelDisplay', this.toggleModelDisplay)
      this.$bus.on('toggleIdDisplay', this.toggleIdDisplay)
      this.$bus.on('setUp', this.setup)
      this.$bus.on('hideEditorFields', () => {
        this.fieldsData = {}
      })
      this.$bus.on('hidePageFields', () => {
        this.fieldsData = {}

        this.fieldsData = JSON.parse(JSON.stringify(this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][this.$store.state.fileCurrentPage]))
      })

      this.$bus.on('saveAutofillDetail', function (payload) {
        that.saveAutofillDetail(payload)
      })

      this.$bus.on('setAutocompleteModel', function (payload) {
        that.setAutcompleteModel(payload)
      })
    },

    components: {
      FormText,
      FormTextarea,
      FormCheckbox,
      FormSelect,
      AutocompleteModel
    },

    methods: {
      resetData () {
        const modelHighlight = document.querySelectorAll('.model-highlight')
        for (const highlight of modelHighlight) {
          highlight.classList.remove('model-highlight')
        }

        const highlighted = document.querySelectorAll('.id-highlight')
        for (const highlight of highlighted) {
          highlight.classList.remove('id-highlight')
        }

        this.fields = {}
        this.offsetTop = document.getElementById('backgroundImage').offsetTop
        this.offsetLeft = document.getElementById('backgroundImage').offsetLeft
        this.width = document.getElementById('backgroundImage').width
        this.height = document.getElementById('backgroundImage').height
        this.$store.commit('setShowPageList', false)
        this.$store.commit('setShowAnnotationMenu', false)
        this.$store.commit('setDragIndex', false)
        this.$store.commit('setAssigningIndexes', false)
        this.$bus.emit('hideControls')
      },

      setup () {
        this.resetData()
        this.getForm()
      },

      resetTabOrders () {
        this.$store.commit('resetTabOrders')
        const prevValue = this.$store.state.assigningIndexes
        this.$store.commit('setAssigningIndexes', !prevValue)
        this.$store.commit('setAssigningIndexes', prevValue)
        this.$store.dispatch('saveTemplate')
      },

      getForm () {
        let that = this
        const apiUrl = this.$store.state.apiUrl
        this.axios.get(apiUrl + 'form/' + this.$store.state.currentFormId).then(response => {
          let formData = response.data[0]
          that.$store.commit('setCurrentFormId', formData._id)
          that.$store.commit('setOutputPath', that.$store.state.viewerStaticUrl + formData.viewer_url)
        })
      },

      toggleIdDisplay (toggle) {
        const highlighted = document.querySelectorAll('.id-highlight')
        for (const highlight of highlighted) {
          highlight.classList.remove('id-highlight')
        }

        if (!toggle) return
        let questionnnaireData = this.$store.state.questionnaires[this.$store.state.currentTemplateName].data

        for (const key in questionnnaireData) {
          if (questionnnaireData.hasOwnProperty(key)) {
            const field = JSON.parse(JSON.stringify(questionnnaireData[key]))
            if (field.model.length) continue
            let targetEl = document.getElementById(field.fieldName)

            // FIELD GROUPS

            if (field.type === 'checkbox-group') {
              Object.values(field.checkboxes).forEach(fieldCh => {
                if (fieldCh.model === '') document.getElementById(fieldCh.id).classList.add('id-highlight')
              })
            }

            if (targetEl === null) continue
            targetEl.classList.add('id-highlight')
          }
        }
      },

      toggleModelDisplay (toggle) {
        const highlighted = document.querySelectorAll('.model-highlight')
        for (const highlight of highlighted) {
          highlight.classList.remove('model-highlight')
        }

        if (!toggle) return

        const elements = document.querySelectorAll('[data-model]')
        for (const el of elements) {
          const model = el.getAttribute('data-model')
          if (!model.length) continue
          const id = this.$store.getters.templateFieldByModel(model)
          if (id === null) continue
          let targetEl = document.getElementById(id)
          targetEl.classList.add('model-highlight')
        }
      },

      setAutcompleteModel (payload) {
        if (payload.hide === true || payload.model.length <= 6) {
          this.isAutocompleteModel = false

          return
        }

        this.isAutocompleteModel = true

        this.autocompleteModelData = {}

        this.autocompleteModelData.top = payload.top
        this.autocompleteModelData.left = payload.left
        this.autocompleteModel = payload.model
        this.autocompleteModelData.fieldId = payload.fieldId
        this.autocompleteModelData.type = payload.type
        this.autocompleteModelData.page = payload.page
      },

      saveAutofillDetail (payload) {
        if (this.$store.state.autofillDetails.map(a => a.pdfField).indexOf(payload.updatePdfField) === -1) {
          this.$store.dispatch('addAutofillDetail', [payload.autofillDetail]).then(response => {
            if (response.data.success === true) {
              this.fieldsData[this.fieldsData.map(field => field.id).indexOf(payload.elId)].model = payload.modelValue
              this.refreshAutofillDetails(payload)
            }
          })
        } else {
          delete payload.autofillDetail.createdAt

          this.$store.dispatch('updateAutofillDetail', {
            autofillId: this.$store.state.autofillId,
            newData: payload.autofillDetail
          }).then(response => {
            if (response.data.success === true) {
              this.fieldsData[this.fieldsData.map(field => field.id).indexOf(payload.elId)].model = payload.modelValue
              this.refreshAutofillDetails(payload)
            }
          })
        }
      },

      refreshAutofillDetails (payload) {
        this.$store.dispatch('getAutofill', this.$store.state.currentFormId).then(response => {
          let autofillId = response.data[0]._id

          this.$store.dispatch('getAutofillDetails', autofillId).then(() => {
            this.setFlash(payload)
          })
        })
      },

      setFlash (payload) {
        this.$bus.emit('addNotification', {
          title: payload.model ? 'Model' : 'Value',
          body: payload.model ? 'Model saved succesfully.' : 'Value saved succesfully.',
          type: 'success'
        })

        this.listOfficialModels = []

        this.$store.dispatch('getOfficialModel').then(() => {
          this.listOfficialModels = this.$store.state.officialModels
        })

        if (payload.model) this.$bus.emit('permitChange')

        let elId = ''

        elId = payload.model ? 'txtFieldModel' : 'txtFieldValue'

        if (document.getElementById(elId) !== null) document.getElementById(elId).classList.add('flashSave')
        else if (document.getElementById(payload.elId) !== null) document.getElementById(payload.elId).classList.add('flashSave')

        setTimeout(() => {
          if (document.getElementById(elId) !== null) document.getElementById(elId).classList.remove('flashSave')
          else if (document.getElementById(payload.elId) !== null) document.getElementById(payload.elId).classList.remove('flashSave')
        }, 400)
      }
    },

    beforeDestroy () {
      this.$bus.$off('saveAutofillDetail')
      this.$bus.$off('pageChange')
      this.$bus.$off('resetTabOrders')
      this.$bus.$off('historyChange')
      this.$bus.$off('toggleModelDisplay')
      this.$bus.$off('toggleIdDisplay')
      this.$bus.$off('setUp')
      this.$bus.$off('hideEditorFields')
      this.$bus.$off('hidePageFields')
      this.$bus.$off('setAutocompleteModel')
    }
  }
</script>

<style lang="scss">
  #pageFields {
    position: absolute;
    display: block;
    width: 82%;
    height: 800px;
    // transform: translateX(-41%);
  }

  .model-highlight {
    outline: #00e4ff solid 2px !important;
  }

  .front {
    z-index: 1;
  }

  .behind {
    z-index: 0;
  }

  .id-highlight {
    outline: rgb(5, 224, 195) solid 4px !important;
  }
  // .id-highlight {
  //   outline: #FF00EA solid 2px !important;
  // }

  .flashSave {
    background-color: rgb(186, 231, 118);
    -webkit-transition: all 0.6s ease;
    -moz-transition: all 0.6s ease;
    -o-transition: all 0.6s ease;
    -ms-transition: all 0.6s ease;
    transition: all 0.6s ease;
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/main/PageFields.vue